export default {
	TimeRegister: 1,
	POS: 2,
	Fulfilment: 3
};
